import React from 'react';
import {
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS,
  PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS,
} from '../../../../app-constants';
import { formatPhoneNumber } from '../../ffwd-homepage.actions';
import './plan_table_view.css';


const PlanTableView = (props) => {
  const {
    planTableData: {
      tableHeading,
      siosText,
      planDetails,
      totalText,
      expandAllText,
      collapseAllText,
    },
    showHideNumbersSection,
    handlePlansShowHide,
    tableType,
    expandedFeature,
    handleNumberSelection,
    selectedPlanNumber,
    handleExpandCollapseAllPlans,
    tableExpandCollapse,
  } = props;

  const numberBadge = numbers => numbers.map((number) => {
    const buttonId = number.replace(/\s+/g, '');
    const selectedClass = (selectedPlanNumber === number) ? PLAN_TABLE_ACCOUNT_SELECTED_CLASS : PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS;
    return (
      <button
        key={buttonId}
        id={`${buttonId}-${tableType}`}
        className={`${selectedClass} badge-account-number`}
        onClick={() => handleNumberSelection(number, selectedClass, tableType)}
      >{formatPhoneNumber(number)}</button>
    );
  });

  const planTableData = (plans, title, siosTitle) => {
    let totalNumberPills = 0;
    const plansView = plans.map((planList, index) => {
      const isosCount = (planList.numbersOnPlan).length;
      totalNumberPills += isosCount;
      const activeRowClass = (planList.numbersOnPlan.filter(value => value === selectedPlanNumber)[0]) ? PLAN_TABLE_ACCOUNT_SELECTED_CLASS : '';
      const accntHideShow = (showHideNumbersSection[index] !== false);
      return (
        <div key={planList.planName} className={`${activeRowClass} row table-row ${accntHideShow && 'p-b-0'}`}>
          <div className="col-6">
            {planList.planName}
          </div>
          <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
            {isosCount}
          </div>
          {expandedFeature &&
            <div className="col-4">
              <button
                onClick={() => handlePlansShowHide(index, tableType, !accntHideShow, true)}
                type="button"
                className={`${accntHideShow ? 'plans-hide-btn' : 'plans-show-btn'} btn`}
              />
            </div>
          }
          {accntHideShow &&
            <div className="col-12 badge-account-section device-badge">{numberBadge(planList.numbersOnPlan)}</div>
          }
        </div>
      );
    });
    return (
      <div className="table">
        <div className="row table-row heading-section">
          <div className="col-6">
            {title}
          </div>
          <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
            {siosTitle}
          </div>
          {expandedFeature &&
            <div
              className="col-4 expand-text"
              onClick={() => handleExpandCollapseAllPlans(plans.length, tableExpandCollapse, tableType)}
              role="button"
              tabIndex="0"
            >
              <span className="table-expand-collapse-text">{tableExpandCollapse ? collapseAllText : expandAllText}</span>
              <button
                type="button"
                className={`${tableExpandCollapse ? 'plans-hide-btn' : 'plans-show-btn'} btn`}
              />
            </div>
          }
        </div>
        {plansView}
        <div className="row table-row total-row">
          <div className="col-6">
            {totalText}
          </div>
          <div className={`text-center ${(expandedFeature) ? 'col-2' : 'col-6'}`}>
            {totalNumberPills}
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {planTableData(planDetails, tableHeading, siosText)}
    </React.Fragment>
  );
};

export default PlanTableView;
